import { vuexTypes } from '../types'
import { RecordFactory } from '@js/records/factory'
import { pairsService } from '@api/pairs.service'

const state = {
  asset_pairs: [],
  asset_pairs_short: []
}

export const mutations = {
  SET_ASSET_PAIRS: (state, assetPairs) => {
    state.asset_pairs = assetPairs
  },
  SET_ASSET_PAIRS_SHORT: (state, assetPairs) => {
    state.asset_pairs_short = assetPairs
  }
}

export const actions = {
  async GET_ASSET_PAIRS ({ commit }) {
    const records = await pairsService.loadAssetPairs()
    const pairs = records.map(record => RecordFactory.createAssetPairRecord(record))
    commit(vuexTypes.SET_ASSET_PAIRS, pairs)
  },
  async GET_ASSET_PAIRS_SHORT ({ commit }, currentAsset) {
    const records = await pairsService.loadAssetPairsShort(currentAsset)
    const pairs = records.map(record => RecordFactory.createAssetPairRecordShort(record))
    commit(vuexTypes.SET_ASSET_PAIRS_SHORT, pairs)
  }
}

export const getters = {
  assetPairs: state => state.asset_pairs,
  assetPairsShort: state => state.asset_pairs_short,
  tradablePairs: state => state.asset_pairs.filter(pair => pair.isTradable && pair.isShowable)
}

export default {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/pairs.module.js